<template>
  <div class="login">
    <!-- <button @click="login">登录</button> -->
    <div class="formBox">
      <div class="form">
        <img
          class="APP_TITLE"
          src="@/assets/image/home_title.png"
          alt="APP_TITLE"
        />
        <div class="formRoom">
          <h1>系统登陆</h1>
          <div class="formlabel">账号</div>
          <a-input
            size="large"
            placeholder="请输入您的账号"
            v-model="ruleForm.username"
            type="text"
          />
          <div class="formlabel">密码</div>
          <a-input
            size="large"
            placeholder="请输入您的密码"
            v-model="ruleForm.password"
            type="password"
            autocomplete="off"
          />
          <div class="loginBtn">
            <a-button
              type="primary"
              block
              size="large"
              :loading="loading"
              @click="login"
            >
              登录
            </a-button>
          </div>
          <!-- <div style="text-align: right">
            <a-button type="link"> 忘记密码 </a-button>
          </div> -->
        </div>
      </div>
    </div>
    <div class="changeip" @click="changeip"></div>
    <div class="changeipMid" v-if="changeipShow">
      <div class="changeipCenter">
        <div style="width: 80%">
          <img
            class="icon_close"
            src="@/assets/image/icon_close.png"
            @click="closeIp"
            alt=""
          />
          <div class="changeipTitle">设置服务器连接地址</div>
          <a-form-model ref="myForm" :model="form" :rules="rules">
            <a-form-model-item ref="url" label="IP地址或域名：" prop="url">
              <a-input
                v-model="form.url"
                size="large"
                placeholder="请输入IP地址或域名"
              />
            </a-form-model-item>
            <!-- <a-form-model-item ref="oss" label="多媒体资源加载地址" prop="oss">
              <a-input
                v-model="form.oss"
                size="large"
                placeholder="请输入多媒体资源加载地址"
              />
            </a-form-model-item> -->
          </a-form-model>
          <a-button
            type="primary"
            block
            class="submit"
            @click="submit"
            size="large"
            >确认</a-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { AppLogin } from "@/request/login";
import { setDynamicMenu } from "@/utils/dynamicMenu.js";
import instance from "@/request/request";
export default {
  data() {
    return {
      ruleForm: {
        username: "",
        password: "",
      },
      loading: false,
      changeipShow: false,
      form: {
        url: "",
        oss: "",
      },
      rules: {
        url: [
          {
            required: true,
            message: "请输入请求地址",
            trigger: "change",
          },
        ],
        oss: [
          {
            required: true,
            message: "多媒体资源加载地址",
            trigger: "change",
          },
        ],
      },
    };
  },
  methods: {
    //登录
    login() {
      if (!this.ruleForm.username) {
        return this.$message.error("请输入您的账号");
      }
      if (!this.ruleForm.password) {
        return this.$message.error("请输入您的密码");
      }
      this.loading = true;
      setTimeout(() => {
        instance
          .post("/sys/login", this.ruleForm, { timeout: 2000 })
          .then((res) => {
            console.log("res", res);
            // this.$store.commit("setProjectId", "");
            localStorage.setItem("token", res.data.token);
            setDynamicMenu().then((menu) => {
              console.log(`/${menu[0].children[0].path}`, "走");
              this.$router.replace(`/${menu[0].children[0].path}`);
            });
          })
          .finally(() => (this.loading = false));
      }, 800);
    },
    //显示切换ip
    changeip() {
      this.form.url = this.$store.state.config.baseURL;
      this.changeipShow = true;
    },
    //关闭
    closeIp() {
      // this.$refs.ruleForm.resetFields();
      this.changeipShow = false;
    },
    //提交
    submit() {
      this.$refs.myForm.validate((valid) => {
        if (valid) {
          this.$store.commit("setBaseURL", this.form.url);
          this.$message.success("设置成功");
          this.closeIp();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style scoped>
.login {
  height: 100vh;
  background-image: url("~@/assets/image/home_bg_gif.gif");
  background-size: cover;
  background-position: center;
  position: relative;
}
.formBox {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  padding: 0 170px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.form {
  width: 384px;
  height: 534px;
  top: 142px;
  /* border: 1px solid red; */
}
.APP_TITLE {
  width: 360px;
  height: 33px;
  margin: 0 12px 28px 12px;
}
.formRoom {
  width: 384px;
  height: 472px;
  background-image: url("~@/assets/image/bg_login.png");
  background-size: cover;
  background-position: center;
  padding-top: 43px;
  padding-left: 28px;
  padding-right: 28px;
  border-spacing: border;
}
h1 {
  font-size: 21px;
  font-weight: 500;
  line-height: 14px;
  color: #212121;
  margin-bottom: 20px;
}
.formlabel {
  padding-top: 21px;
  padding-bottom: 14px;
  font-size: 13px;
  font-family: SourceHanSansSC-Regular;
  line-height: 14px;
  color: #212121;
}
.loginBtn {
  margin-top: 21px;
}
.changeip {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  position: fixed;
  top: 10px;
  left: 10px;
  background: #1473fb;
  cursor: pointer;
}
.changeipMid {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
}
.changeipCenter {
  width: 40%;
  /* min-height: 400px; */
  border-radius: 20px;
  background: #fff;
  position: relative;
  padding: 60px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  transition: all 1s;
}
.icon_close {
  width: 40px;
  height: 40px;
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;
}
.changeipTitle {
  text-align: center;
  font-size: 24px;
  font-weight: 500;
  line-height: 20px;
  color: #011733;
  margin-bottom: 50px;
}
.submit {
  margin-top: 50px;
}
</style>